var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100%",
    viewBox: "0 0 842 880",
    enableBackground: "new 0 0 842 880",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M348.000000,444.500000  C334.566528,444.982697 325.434448,452.000916 320.609985,464.044067  C313.540070,481.692322 319.476349,503.205475 334.487244,511.523010  C348.380249,519.221069 366.369812,514.653137 374.074799,500.039429  C382.276306,484.483978 380.512604,465.025726 370.058655,453.944672  C364.096283,447.624664 356.817932,445.061188 348.500000,444.500000  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M647.500000,550.500000  C645.222778,538.992798 643.502747,537.215454 632.500000,534.999939  C623.261292,533.139709 613.155212,539.894287 612.063049,549.007568  C611.307007,555.316223 614.420532,559.924133 619.476868,563.532471  C625.115540,567.556396 631.576294,570.024231 637.523926,573.458557  C642.246948,576.185852 646.003784,579.690063 647.452759,585.012878  C649.647583,593.075623 643.398010,602.573608 635.022766,605.076233  C629.334839,606.775879 623.855774,605.607056 618.531067,604.366638  C610.463684,602.487427 608.321350,595.789490 607.500000,588.500000  "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M658.500000,462.500000  C657.456177,461.646179 658.071533,460.494537 658.027954,459.498779  C657.723328,452.544250 654.332764,448.680237 647.549072,446.356659  C629.155212,440.056305 610.630005,449.375275 604.828308,466.943298  C598.542603,485.976990 607.198853,507.148193 623.550537,512.855225  C634.765259,516.769409 646.134094,516.986755 656.000000,508.500000  "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M240.500000,462.500000  C240.500000,462.333344 240.510574,462.165894 240.498489,462.000122  C239.417282,447.162720 233.456314,446.182709 220.976654,444.695953  C203.850342,442.655579 188.981903,454.970215 185.880981,471.978302  C183.916229,482.754669 185.694794,492.437164 191.514832,501.490448  C201.082581,516.373352 225.898483,519.933167 238.000000,508.500000  "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M417.500000,367.000000  C412.178833,367.190979 408.933899,371.522644 404.579773,373.662354  C398.142914,376.825562 391.538971,378.642365 384.498291,378.962769  C375.840118,379.356781 367.151093,378.472198 358.499725,379.497620  C345.225586,381.071014 332.605957,384.895203 320.499359,390.498627  C317.505005,391.884552 317.011261,396.389099 312.860840,396.232849  C309.908356,390.564941 311.365265,380.118042 315.453674,375.459351  C321.234436,368.872192 328.640076,366.777618 336.997711,366.443115  C341.510498,366.262543 345.993195,365.417633 350.503662,365.044098  C352.109802,364.911102 353.002899,363.963409 354.000000,363.000000  "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M418.000000,370.000000  C408.012939,386.863434 392.624390,396.038422 373.968597,399.846222  C365.778137,401.517944 357.301361,400.968781 348.989685,399.044586  C338.790192,396.683350 328.650452,393.763794 318.000000,394.250000  "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M427.500000,381.500000  C429.646027,381.645416 431.288544,382.717957 433.038269,383.945435  C443.507477,391.289581 455.569305,393.481750 467.997314,394.531799  C476.294342,395.232880 484.633636,395.735077 492.037048,400.441742  C496.213043,403.096619 501.091614,403.749084 505.924011,404.837433  C511.131592,406.010254 516.349426,408.121277 521.500000,410.000000  "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M354.500000,358.000000  C353.037872,356.312531 351.130981,356.026764 349.000824,355.969635  C331.422302,355.498322 314.812103,352.001526 298.830688,343.831146  C289.343689,338.981049 280.353821,333.041321 270.438629,329.156677  C264.438568,326.805939 257.833344,326.000000 251.500000,324.500000  "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 11,
    d: " M581.500000,515.500000  C580.384216,508.280182 576.869812,502.391296 572.051819,496.954102  C559.479614,482.766052 548.895142,466.961670 536.187378,452.831512  C531.874084,448.035400 527.655945,445.593689 521.500000,446.000000  "
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M555.500000,252.500000  C551.716553,253.843674 551.733887,257.646759 550.565674,260.526642  C545.249268,273.632568 540.777222,287.117371 534.822937,299.917633  C529.215942,311.971344 520.217285,321.620087 509.000000,329.000000  "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M546.000000,307.500000  C547.245239,308.371246 548.439575,308.261810 550.010864,308.138580  C560.145935,307.343964 569.602356,309.226746 576.440002,317.549316  C580.107910,322.013733 585.524780,324.056610 590.559143,328.385010  C583.914246,329.545319 579.723694,334.701416 573.504211,334.409668  C571.475464,334.314514 570.532410,335.709442 569.581360,336.588043  C560.963867,344.549042 550.465210,348.576660 539.529053,352.090363  C527.991760,355.797211 517.025208,361.209564 505.012543,363.563934  C502.461700,364.063904 499.384583,363.320404 497.500000,366.000000  "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: " M278.500000,445.500000  C277.333344,445.666656 276.149353,445.756012 275.002869,446.012817  C268.430664,447.485077 267.500000,448.681183 267.500000,455.500000  C267.500000,472.000000 267.215942,488.507782 267.668121,504.995392  C267.809021,510.131805 265.760406,512.293457 261.494537,513.480347  C259.861542,513.934631 258.166656,514.166687 256.500000,514.500000  "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 11,
    d: " M387.500000,445.000000  C389.166656,445.333344 391.015717,445.316620 392.463135,446.070770  C395.766571,447.791931 399.273529,448.572784 400.713623,453.436768  C405.303925,468.940735 410.484406,484.298828 416.212006,499.419708  C417.936829,503.973236 419.171631,508.239624 419.000000,513.000000  "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M573.000000,574.000000  C573.827820,571.910461 575.780945,571.000488 577.521240,570.038452  C586.309387,565.180359 589.616699,559.378357 587.952087,550.508972  C586.663513,543.643433 580.568481,538.118958 571.474792,537.269836  C565.634155,536.724304 559.128845,534.992798 553.500000,539.000000  "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 11,
    d: " M376.500000,536.000000  C377.333344,536.166687 378.180573,536.282959 378.997742,536.508240  C383.900909,537.859924 387.880035,539.657288 389.646942,545.455200  C394.208160,560.422241 399.211273,575.274231 404.672455,589.935791  C406.354370,594.451050 407.805542,598.709900 407.500000,603.500000  "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M576.500000,335.000000  C576.333374,336.000000 576.504822,337.273041 575.950256,337.959839  C564.045654,352.702576 551.151184,366.279358 532.479065,372.436493  C528.623535,373.707916 524.528381,374.388397 520.487854,374.905182  C518.507019,375.158539 516.855286,375.554840 515.500000,377.000000  "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M439.000000,658.500000  C441.382111,658.873962 443.060028,657.593262 444.485687,655.987305  C449.868317,649.923950 454.215454,643.119934 457.888275,635.942810  C458.977997,633.813354 460.190399,631.000000 457.455200,627.878113  C444.283478,638.329346 440.292511,654.153015 433.500000,668.250000  "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M448.000000,403.000000  C449.977051,408.382935 455.221680,408.545105 459.518829,409.942108  C473.802429,414.585876 488.199585,414.175140 502.468964,409.896515  C504.970917,409.146301 508.106506,410.941101 510.000000,408.000000  "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M266.500000,657.500000  C267.866333,657.298645 269.203644,657.841431 270.547882,656.549866  C278.425140,648.981201 285.229980,640.660095 289.455231,630.481384  C290.161560,628.779846 291.651001,626.688721 289.469727,625.040100  C287.222321,623.341553 285.278961,625.215515 284.073059,626.565247  C276.226898,635.347046 270.300201,645.307251 266.484833,656.494812  C265.156311,660.390503 261.958557,663.563477 262.000000,668.000000  "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M263.500000,328.500000  C272.527618,337.805725 279.753021,348.844574 290.959259,356.063232  C299.475983,361.549408 308.349335,365.845642 318.507263,366.932068  C320.268341,367.120422 321.317627,368.031433 322.500000,369.000000  "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: " M491.500000,445.500000  C495.724426,445.499054 499.158813,447.719971 502.500000,449.562134  C502.500000,468.999298 502.546234,488.499908 502.434937,507.999634  C502.422607,510.165131 503.436676,511.138641 505.002899,511.994690  C507.650757,513.441956 510.524048,514.151550 513.500000,514.500000  "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 13,
    d: " M259.000000,541.000000  C259.000000,560.666687 259.000000,580.333313 259.000000,600.000000  "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M486.500000,445.500000  C481.753998,446.087341 478.901428,447.753113 478.242798,453.470367  C477.574493,459.271240 474.844299,464.836914 472.997528,470.499176  C470.006775,479.668884 467.017639,488.839172 463.990662,497.996918  C462.900543,501.295013 461.647034,504.505585 457.500000,505.000000  "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 11,
    d: " M552.500000,573.000000  C575.520691,573.093262 569.255981,571.101562 581.010620,588.492798  C584.278809,593.328186 586.114380,599.270630 591.509705,602.483704  C594.565369,604.303345 597.793640,605.658813 601.500000,605.000000  "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M475.500000,536.000000  C470.364960,536.864929 467.708893,538.988953 466.176727,544.916443  C462.320312,559.835632 456.783325,574.317200 452.040131,589.012939  C451.031189,592.138916 448.935944,593.687683 446.000000,594.500000  "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M534.000000,454.500000  C531.766479,456.333252 531.464172,458.801758 531.474670,461.500092  C531.529053,475.499878 531.539124,489.500153 531.487122,503.499939  C531.448792,513.819397 532.289795,513.198486 541.500000,514.500000  "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M361.000000,235.500000  C356.402069,232.998596 353.124664,228.268814 346.722382,227.165329  C346.555206,235.459473 342.593323,242.381577 339.330719,249.421555  C336.101746,256.389008 337.786224,264.400177 333.716522,271.795502  C330.540405,266.142914 330.474304,260.365692 329.667114,254.974976  C328.360962,246.251373 330.443054,237.763107 333.446503,229.480606  C335.690247,223.293167 334.455078,216.849701 334.000000,210.500000  "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M472.500000,343.500000  C466.684235,348.728455 460.540619,353.451508 453.581757,357.153687  C452.257141,357.858398 450.996643,358.264160 450.031342,357.913666  C444.301239,355.833252 438.656616,357.765106 433.003571,358.066956  C429.314667,358.263916 427.959717,357.110168 427.429749,353.510345  C426.377625,346.363983 429.816345,340.398224 432.641541,334.568604  C441.171600,316.967316 454.736145,303.898926 472.094452,295.188232  C478.058960,292.195099 484.547699,289.933441 491.419983,288.590576  C495.625305,287.768829 500.766693,286.243958 504.098419,282.078735  C505.920776,279.800476 508.493958,277.784973 512.001282,278.493530  C516.259399,279.353729 518.233154,282.054474 516.928711,286.479004  C514.509460,294.685394 514.125854,303.259491 512.466736,311.592926  C511.684998,315.519623 510.782501,319.353363 508.788208,322.359497  C506.617310,325.631927 507.437592,328.785095 507.000000,332.000000  "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M380.000000,205.500000  C371.890381,198.718399 362.522919,195.110855 351.999115,194.515488  C347.611603,194.267258 343.990112,191.780060 340.072052,190.308228  C336.469055,188.954758 335.922180,189.849289 335.991486,193.000183  C336.100067,197.935349 335.836517,202.782013 334.091461,207.533600  C333.313324,209.652374 331.546570,210.727661 330.424408,212.450775  C325.146118,220.556000 322.956421,229.575607 322.013916,239.001389  C321.058807,248.553223 323.045074,257.644226 326.461853,266.514709  C327.063934,268.077850 327.166687,269.833344 327.500000,271.500000  "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M561.000000,240.000000  C561.000000,240.333328 561.142578,240.782654 560.979431,240.983261  C554.518005,248.927017 556.436707,258.558289 556.177673,267.505157  C555.768127,281.651428 552.325073,294.961273 545.301575,306.883118  C537.220276,320.600555 525.681152,331.327820 511.529388,339.053833  C508.101624,340.925171 504.769836,342.850464 501.022339,344.068695  C499.265228,344.639923 497.917053,344.413300 496.500000,343.500000  "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M504.500000,235.500000  C502.932465,237.558914 502.592987,239.357712 503.842224,242.072601  C505.628387,245.954208 506.272552,250.351807 507.531250,254.490494  C508.005280,256.049072 508.587585,257.686340 509.553131,258.959717  C511.348236,261.327148 514.300903,261.140961 515.960510,258.475403  C519.271912,253.156921 521.063049,247.509644 521.144165,241.001801  C521.294922,228.905579 517.308838,218.737961 510.543671,208.800079  C507.186157,203.867966 507.691498,196.783234 509.086456,190.578613  C507.833344,189.368820 506.986481,189.550049 505.443451,190.396973  C499.435516,193.694504 492.659454,194.511200 485.993530,195.454239  C481.849487,196.040512 478.782410,199.457748 474.500000,199.500000  "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M581.000000,448.500000  C582.039062,463.657074 581.237610,478.834534 581.518982,493.999634  C581.566467,496.559296 581.043030,498.798584 579.000000,500.500000  "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M510.000000,209.500000  C507.398407,214.265533 509.557739,219.021149 510.676971,223.455338  C512.269165,229.763321 514.044983,236.111664 514.278992,242.508087  C514.491089,248.303177 512.833374,254.166672 512.000061,260.000000  "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M310.000000,299.500000  C304.222443,296.771423 302.277985,290.921692 299.626373,285.932831  C295.073914,277.367615 291.973297,268.186157 290.418335,258.513123  C290.017517,256.019745 289.440216,253.177826 286.500000,252.000000  "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M375.000000,353.500000  C375.197479,350.067932 372.509583,347.412506 370.779999,345.725555  C363.385437,338.513397 360.290375,328.337799 353.354279,321.140442  C344.454132,311.905090 338.539337,299.668854 325.580383,294.305786  C319.386993,291.742706 315.573578,285.689941 312.012451,279.992218  C311.016144,278.398071 310.648102,276.164093 308.000000,276.500000  "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M320.500000,244.000000  C316.381378,242.816330 312.990234,239.954773 308.519409,239.355255  C305.583344,238.961563 302.670349,238.912048 300.035126,239.629059  C295.079987,240.977280 290.376312,241.279480 285.472595,239.579010  C284.085815,239.098099 282.281128,239.181732 281.000000,240.499908  C281.000000,241.000000 280.782806,241.699341 281.031891,241.970734  C286.669647,248.113251 285.789246,255.729416 285.408417,262.995209  C284.702881,276.455902 287.087097,289.321747 293.665314,300.906128  C299.628418,311.407288 307.455597,320.628296 318.455414,326.582367  C319.784180,327.301636 320.762909,327.326324 322.000000,327.000000  "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M259.500000,637.000000  C253.200577,646.834717 247.757126,657.113708 243.512543,668.004883  C242.327957,671.044373 241.678009,674.215820 242.014282,677.498535  C242.307434,680.360168 244.610794,681.543335 246.976288,679.964478  C248.437378,678.989197 249.906097,677.847717 250.952332,676.463928  C253.459839,673.147400 256.185028,670.355469 260.493896,669.470337  C265.312500,668.480469 268.398987,664.877563 271.446320,661.452271  C273.168335,659.516724 274.970642,659.141602 277.249939,659.749939  C277.605896,664.064758 274.224121,667.332153 273.922974,671.494446  C273.881470,672.068115 272.736328,672.557678 273.006622,673.498108  C273.432312,674.979248 272.070312,676.653259 273.953979,678.061523  C276.278748,679.799438 277.614899,677.505127 278.913391,676.832764  C281.366425,675.562439 281.469513,671.130615 285.500000,671.500000  "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M429.500000,553.500000  C425.048492,555.125977 423.333374,558.937866 422.011566,563.003784  C419.306458,571.324585 416.532349,579.627197 414.065369,588.019226  C413.062622,591.430298 411.307617,593.787476 408.000000,595.000000  "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M441.000000,463.000000  C437.180450,464.067505 435.527771,466.792236 434.423401,470.477051  C431.655273,479.713196 428.339966,488.785583 425.582703,498.024658  C424.552979,501.475220 423.038269,503.985168 419.500000,505.000000  "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M530.500000,591.500000  C527.453735,603.083557 528.688110,603.456238 514.499084,603.974304  C510.005066,604.138367 505.497925,603.916260 501.000702,604.028015  C497.731628,604.109314 494.811523,603.478455 492.500000,601.000000  "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M305.500000,500.500000  C305.588043,504.418243 303.801666,507.750031 301.947601,510.969818  C300.581024,513.343079 297.788086,513.358704 295.497833,513.424561  C288.337067,513.630127 281.166534,513.477966 274.000061,513.513000  C271.744781,513.523987 269.966827,512.639648 268.500000,511.000000  "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: " M539.500000,536.000000  C540.500000,536.166687 541.503662,536.313965 542.499390,536.503052  C549.595581,537.850647 551.500000,540.075684 551.500000,547.000000  C551.500000,562.666687 551.500000,578.333313 551.500000,594.000000  C551.500000,600.924255 549.595581,603.149353 542.499390,604.496887  C541.503662,604.685913 540.500000,604.833313 539.500000,605.000000  "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M297.000000,589.500000  C296.500000,591.500000 296.086731,593.526672 295.482178,595.494507  C294.177490,599.741516 292.246490,603.070496 287.008698,603.587952  C279.661560,604.313843 272.332214,603.786011 264.998840,603.946411  C263.657288,603.975769 262.399750,603.133789 261.500000,602.000000  "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M456.000000,251.500000  C457.282166,248.850388 456.071838,247.180801 454.031097,245.463058  C446.384796,239.027145 437.009796,235.332092 429.025299,229.465576  C427.187164,228.115005 425.934357,228.630630 423.952454,229.373108  C416.397522,232.203461 409.915833,236.998581 406.391174,243.705566  C404.045685,248.168640 400.380554,253.980469 404.000000,260.000000  "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M390.500000,198.000000  C394.077393,191.694992 398.795929,186.590851 405.495148,183.489548  C412.953094,180.037018 419.353577,175.314972 423.489502,167.994064  C423.923706,167.225540 424.212158,166.374695 424.955688,165.953751  C427.693726,166.643463 427.648529,168.649307 428.563782,169.955307  C432.226410,175.181778 436.521423,179.654633 442.461578,182.578094  C451.149994,186.854141 458.423676,192.843246 462.500000,202.000000  "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M310.500000,357.500000  C321.335083,361.840485 332.607269,362.376740 343.986969,360.899628  C347.526062,360.440216 351.004059,360.769775 354.501526,360.521362  C355.628967,360.441315 355.709351,361.145325 355.250000,362.000000  "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M438.500000,213.500000  C441.926849,207.503647 447.839600,205.305832 454.017822,204.674210  C459.560791,204.107544 464.195099,202.297791 468.538544,199.051590  C469.626129,198.238754 470.921783,196.999985 472.485779,197.541107  C475.007385,198.413559 473.480011,200.464157 473.475891,201.999939  C473.446625,212.956238 474.441528,223.467499 480.820618,233.118576  C484.088318,238.062408 483.926117,244.482361 484.106812,250.496796  C484.163147,252.372467 482.606598,253.194489 482.500000,254.750000  "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M344.000000,657.500000  C341.197723,659.433777 339.988861,653.846558 336.364532,656.299927  C332.556305,658.877869 329.439148,661.904236 327.147400,665.591614  C325.752594,667.835876 324.228424,670.440430 324.467010,673.502563  C324.725189,676.815857 326.123840,677.627014 329.010498,676.018799  C330.965179,674.929871 332.417114,673.298645 333.428467,671.460632  C334.514771,669.486572 335.968994,668.877502 338.000000,669.000000  "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M241.500000,549.500000  C238.954163,549.407166 239.732834,547.483521 239.469925,546.005371  C238.281067,539.321350 236.618912,537.478516 229.994995,537.083923  C223.517990,536.698120 216.999878,536.978149 210.500092,537.015564  C208.889420,537.024780 207.568375,537.803406 206.500000,539.000000  "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M293.000000,301.500000  C290.583252,303.332947 287.647766,302.534607 284.986450,302.901794  C277.618530,303.918488 271.032074,306.477875 266.066223,312.058929  C262.876160,315.644196 260.118805,319.537781 255.534866,321.578308  C254.947052,321.839966 254.833344,323.166656 254.500000,324.000000  "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: " M480.500000,536.500000  C483.886261,536.341248 486.696228,537.608643 489.583954,539.361694  C491.314545,540.412292 491.509308,541.416260 491.508179,543.000000  C491.495331,561.333313 491.495331,579.666687 491.508179,598.000000  C491.509308,599.583740 491.503418,600.768616 489.543152,601.601562  C486.592102,602.855469 483.829498,604.488525 480.500000,604.500000  "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 11,
    d: " M435.000000,448.250000  C439.427002,449.791168 439.114655,454.371338 440.318817,457.568237  C444.774078,469.396759 448.585754,481.472351 452.465668,493.511047  C454.574188,500.053375 458.733582,506.108276 457.500000,513.500000  "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M527.500000,548.500000  C526.588074,538.842407 525.093689,536.944946 514.500000,536.995850  C509.500092,537.019897 504.499146,537.054382 499.500397,536.975647  C497.216187,536.939697 495.099945,537.133179 493.500000,539.000000  "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: " M193.500000,536.500000  C197.432922,535.953552 200.349136,538.264587 203.521072,539.960571  C205.018707,540.761292 204.473114,541.953369 204.475082,543.000061  C204.509537,561.333313 204.477097,579.666748 204.537674,597.999878  C204.543350,599.713196 204.093124,600.725586 202.522095,601.542480  C199.657318,603.031860 196.830124,604.490356 193.500000,604.500000  "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M345.500000,242.000000  C345.833344,243.000000 346.763550,244.424728 346.403229,244.931137  C344.051331,248.236465 346.279877,250.886124 347.583832,253.457489  C348.865967,255.985825 351.210846,257.989166 352.410919,260.541870  C354.179901,264.304596 355.583160,268.139282 356.214661,272.468689  C357.328339,280.103821 363.354370,284.303131 370.037048,286.904877  C377.712952,289.893219 385.700256,293.164764 392.131744,297.541168  C399.251038,302.385590 406.585419,308.037933 412.138672,315.395325  C417.981598,323.136444 422.955841,331.131531 425.422546,340.520355  C425.815063,342.014343 426.406860,343.077026 427.500000,344.000000  "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 11,
    d: " M421.000000,537.250000  C424.641602,538.889954 426.826996,541.465332 428.100983,545.467834  C432.848083,560.381653 437.538727,575.348694 443.276794,589.890747  C445.033112,594.341797 446.085999,598.416077 446.000000,603.000000  "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M297.500000,293.500000  C300.258362,300.549713 304.547943,307.287750 311.159973,310.127563  C318.269806,313.181152 318.777740,319.536713 321.835358,324.599426  C322.838379,326.260162 323.622253,328.053772 324.997070,329.502777  C333.355255,338.312286 342.362152,346.257660 354.018646,350.448120  C356.777863,351.440033 359.694153,351.901672 361.000000,355.000000  "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M406.000000,379.000000  C393.778473,386.096497 380.679443,389.544342 366.500000,388.500000  "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M510.500000,671.500000  C510.666656,672.166687 510.907318,672.824463 510.988037,673.501404  C511.519958,677.962341 513.908875,679.370361 517.473816,676.961243  C524.129639,672.463562 527.138550,665.919067 527.539124,658.001953  C527.617249,656.457275 527.246033,655.224060 525.976257,654.544373  C524.681091,653.851135 523.353455,654.776184 522.551147,655.552795  C519.589172,658.419922 515.895691,661.053772 514.208496,664.599243  C511.302673,670.705566 505.246338,673.457153 501.496857,678.497681  C500.112274,680.359009 498.012329,680.981201 496.025726,680.410461  C493.331451,679.636475 494.121857,677.034058 493.997955,675.000122  C493.813019,671.964111 494.950439,669.260010 495.979279,666.492310  C501.211334,652.417725 507.653534,639.049011 517.408752,627.423401  C519.009766,625.515442 520.646912,624.670654 522.441528,625.611511  C524.745605,626.819458 523.084351,628.974731 522.446655,630.477356  C517.820374,641.379272 511.135315,650.922424 503.042236,659.539673  C501.815247,660.846130 500.565369,661.118774 499.000000,661.000000  "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M584.500000,658.500000  C583.666687,659.166687 582.136902,659.811584 582.115234,660.503601  C581.992798,664.423584 579.844849,667.556580 578.537415,671.014160  C578.130493,672.089966 577.948181,673.354858 578.060425,674.494019  C578.176453,675.671936 577.261353,677.089539 578.973694,678.047058  C580.816040,679.077332 581.836060,678.214966 583.012939,677.012634  C586.343262,673.610413 589.894165,670.387268 591.986450,665.993530  C593.031616,663.798889 594.762451,663.191589 597.000000,663.500000  "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M475.000000,656.000000  C475.833344,656.000000 476.979614,656.359375 477.453583,655.946716  C486.033081,648.475769 493.391785,640.098694 497.026001,629.008545  C497.618378,627.200928 497.499878,625.504211 495.949829,624.584534  C494.663971,623.821594 493.559845,625.048035 492.472107,625.966980  C483.893280,633.214417 479.266785,643.010254 475.042236,653.017822  C472.479858,659.087830 470.405151,665.361938 467.962860,671.485168  C467.050537,673.772522 466.375122,676.032776 466.500000,678.500000  "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M358.500000,658.000000  C359.906860,660.567993 363.273956,659.950684 365.028015,662.024597  C362.855011,666.343811 360.525665,670.605957 358.598724,675.042908  C358.067352,676.266418 356.926056,678.190308 358.995605,679.506897  C360.861511,680.693970 362.146484,679.508179 363.501007,678.501343  C366.482849,676.285095 368.827576,673.420715 370.906525,670.434937  C371.934540,668.958496 372.832855,668.290833 374.500000,668.500000  "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: " M238.500000,507.500000  C238.500000,502.666656 238.500000,497.833344 238.500000,493.000000  C238.500000,487.237640 236.716278,485.021179 230.994354,484.032654  C228.862518,483.664337 226.666672,483.666656 224.500000,483.500000  "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M434.000000,669.000000  C439.101379,672.588562 437.220703,678.046753 436.771027,682.476746  C436.087341,689.211365 432.830444,695.340820 428.980072,700.986389  C428.458099,701.751770 427.678772,702.346008 426.997162,702.997009  C425.957672,703.989807 424.634399,703.541138 423.505585,703.438477  C421.767700,703.280457 422.001251,701.787476 421.986694,700.500122  C421.917816,694.409973 424.406311,688.960449 426.601379,683.541077  C428.665680,678.444641 430.213928,673.055420 433.727234,668.649597  C430.098480,666.264954 426.425415,669.732910 423.000000,668.000000  "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M484.000000,372.000000  C486.594940,376.280579 491.166504,375.435669 495.013824,375.880585  C499.454437,376.394104 504.063751,376.477539 508.484955,375.887268  C514.993652,375.018311 517.628174,380.004547 520.876343,383.611359  C523.982544,387.060669 525.603638,391.846191 524.338440,396.455658  C523.237366,400.466949 522.744751,404.407104 522.326294,408.482178  C522.159180,410.109711 523.389404,410.425751 523.500000,411.500000  "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M289.000000,667.000000  C294.058899,667.444092 300.826813,662.595032 301.490173,657.998596  C301.921692,655.008423 299.382355,654.851562 298.063629,655.610535  C291.550842,659.359314 287.662231,665.218567 286.041626,672.509277  C285.507935,674.909973 286.529388,677.402893 288.575287,678.334717  C290.253876,679.099243 292.543976,678.609497 294.523285,677.543213  C300.347351,674.405457 304.158417,669.183411 308.500000,664.500000  "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M461.000000,236.250000  C457.577606,228.369324 452.528778,221.789413 444.971069,217.551575  C438.643280,214.003372 431.915955,211.126068 427.687469,205.744446  C425.135254,204.945038 424.508850,206.602646 423.512329,207.513489  C419.749756,210.952606 415.825287,214.069077 411.016205,216.039566  C404.047211,218.895050 398.545654,223.391251 394.400116,229.936737  C388.464905,239.307999 381.033813,247.724121 376.500000,258.000000  "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M378.000000,212.000000  C379.196808,213.019501 379.301636,214.100250 378.526489,215.514526  C376.448853,219.305298 374.395050,223.116806 372.540649,227.019318  C371.482697,229.245911 369.901520,231.776520 370.161407,233.980972  C371.283081,243.495392 365.219879,249.625305 360.564209,256.543213  C358.872955,259.056274 359.785858,262.833405 357.000000,265.000000  "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M546.500000,668.500000  C547.333313,665.166687 548.244690,661.850037 548.964844,658.492432  C549.291016,656.971558 549.166138,655.235779 547.476196,654.559448  C546.113953,654.014160 544.499390,654.553162 543.543274,655.541809  C540.263855,658.932861 536.885193,662.292175 534.095276,666.070435  C532.114929,668.752258 532.664490,672.360779 533.115540,675.483337  C533.526917,678.331482 537.307190,679.124939 539.959717,676.950867  C542.375488,674.970642 544.478088,672.595032 545.500000,669.500000  "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M392.500000,664.500000  C389.002960,669.597778 384.967987,674.224426 380.532684,678.533630  C379.052795,679.971497 377.259705,681.106750 375.550415,680.381226  C373.007111,679.301697 373.823975,676.510864 374.071686,674.508850  C375.284851,664.703186 380.744141,656.580444 385.043762,648.021973  C386.951263,644.225098 389.333344,640.666687 391.500000,637.000000  "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M397.000000,238.000000  C397.396545,239.972534 396.418854,241.241486 395.024841,242.526947  C388.632507,248.421539 387.320435,257.407288 382.138977,264.107483  C381.314148,265.174042 381.668457,268.166229 382.609070,269.418060  C388.264465,276.944733 390.884460,285.704163 393.500000,294.500000  "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M417.000000,212.000000  C412.466278,206.472961 406.704865,203.329178 399.499939,203.001358  C393.511322,202.728867 390.181274,197.327301 385.034973,195.338806  C382.406067,197.362427 383.544373,200.591705 382.179749,203.097870  C379.247528,208.482895 374.647278,212.317963 370.991791,216.993576  C364.772827,224.947952 361.042938,233.891113 360.559967,244.002869  C360.369720,247.985397 357.657776,252.000000 360.500000,256.000000  "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M495.000000,257.000000  C492.916504,254.347275 492.888306,250.950928 492.648560,247.987976  C491.472900,233.457687 484.342896,221.983994 475.000000,211.500000  "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M355.500000,272.500000  C350.158569,273.556305 349.540222,277.463715 349.450073,281.998993  C349.310974,288.998932 350.185120,296.024261 349.000000,303.000000  "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M524.500000,365.500000  C515.609863,367.514343 506.494812,367.793396 496.843353,368.813080  C501.562561,373.216339 506.797852,370.865326 511.500000,371.500000  "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M563.500000,238.500000  C557.567444,240.047348 551.227234,240.510605 545.564880,239.216293  C536.854126,237.225220 529.382751,238.808044 522.000000,243.000000  "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M516.500000,569.500000  C508.500000,569.500000 500.500000,569.500000 492.500000,569.500000  "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M205.500000,570.000000  C211.166672,570.000000 216.833618,569.963684 222.499924,570.008911  C230.015793,570.068848 231.710388,571.791077 232.000000,579.500000  "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M531.500000,312.500000  C527.266174,318.057648 523.332886,323.834015 517.549072,328.067017  C514.753967,330.112671 512.900818,333.427704 508.472382,332.091553  C506.009827,331.348602 504.128967,334.007690 502.673584,335.210114  C497.823059,339.217560 494.264465,344.496368 492.000000,350.500000  "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M471.500000,677.500000  C479.646881,675.379333 485.673096,668.545044 485.984680,660.999390  C486.052826,659.349304 486.480316,657.290283 484.467224,656.594849  C483.323242,656.199646 482.116272,657.476929 480.960999,657.891235  C477.518524,659.125732 476.410217,663.974304 472.000000,663.500000  "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M423.500000,667.500000  C423.566254,664.264832 425.242737,661.317627 425.072510,657.996277  C424.995178,656.487244 424.773468,655.070557 423.464447,654.598572  C422.408142,654.217712 421.184875,654.471252 419.939972,655.421326  C414.551544,659.533813 415.600250,665.298279 422.500000,668.500000  "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M427.000000,356.500000  C424.458923,357.517365 422.795166,359.625275 421.029724,361.527588  C417.650391,365.168945 417.873596,367.801636 420.419983,372.047974  C422.902008,376.186951 425.373291,380.313782 427.423767,384.806580  C430.931702,392.492798 436.621613,399.506439 445.838165,401.499084  C446.892670,399.863007 445.812744,397.239716 448.500000,396.500000  "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M307.000000,273.000000  C306.079834,280.824615 310.928802,287.825897 310.393799,295.492584  C309.981140,301.406311 314.510864,305.539856 315.000000,311.000000  "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M359.750000,652.000000  C357.521576,661.982910 350.911987,669.078247 344.032379,676.032043  C342.705750,677.372925 341.299225,678.754456 339.545807,677.905396  C337.553009,676.940491 338.305939,674.948425 338.314911,672.999146  C338.331909,669.304749 339.387756,666.138611 341.000000,663.000000  "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: " M642.500000,483.500000  C644.174377,483.589600 645.819397,483.614197 647.513062,483.929749  C655.842712,485.481537 656.500000,486.109894 656.500000,494.000000  C656.500000,498.500000 656.500000,503.000000 656.500000,507.500000  "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M463.500000,299.500000  C460.111359,293.995972 456.465515,288.866760 451.106903,284.857147  C447.153259,281.898773 442.544159,280.503357 438.349091,278.285461  C435.188171,276.614349 431.777924,275.282745 429.055725,272.935394  C427.103973,271.252411 425.048340,271.805695 423.552765,272.599426  C416.434845,276.377258 409.255249,280.136780 402.587189,284.629425  C398.235992,287.561066 395.526917,292.347137 393.000000,297.000000  "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M488.500000,288.000000  C488.164948,285.410889 488.851685,282.962891 489.492706,280.498108  C491.343597,273.381409 486.974915,267.714386 484.978241,261.506989  C483.031494,255.454910 478.462280,250.793289 476.007263,244.708115  C472.648102,246.615417 470.741119,249.220749 470.763885,252.999924  C470.803284,259.545807 465.475830,262.801575 461.881256,266.895752  C457.383698,272.018341 452.439606,276.708038 449.500000,283.000000  "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M400.000000,360.500000  C398.537445,365.158539 393.810425,365.718231 390.454956,367.931732  C387.675110,369.765472 384.500000,371.000000 381.500000,372.500000  "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M434.000000,259.500000  C428.398590,256.320160 422.894073,256.338074 417.699249,260.192749  C415.282654,258.429321 416.116486,256.079071 416.016724,253.999191  C415.786102,249.190933 413.656677,247.059921 409.000122,246.991119  C403.006500,246.902573 397.365662,247.129684 393.764618,253.364029  C393.133057,254.457382 390.707611,256.864899 388.000000,256.000000  "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M333.500000,271.500000  C332.065521,274.827728 334.755829,277.209595 335.589081,279.973145  C336.782379,283.930725 338.632324,287.694672 338.000000,292.000000  "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M437.500000,358.500000  C439.791412,362.438141 443.651489,362.772186 447.494873,362.440430  C453.672028,361.907227 459.814484,362.842896 465.406708,364.770660  C470.069611,366.378021 474.536804,368.265106 479.471008,369.159943  C481.767303,369.576355 483.441833,369.279816 485.532288,368.599121  C489.250793,367.388275 493.166656,366.348633 497.000000,368.500000  "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M320.000000,280.000000  C325.921753,283.871033 330.781464,289.078888 337.423218,292.165222  C345.871735,296.091187 352.542450,308.949554 351.500000,317.000000  "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M348.500000,331.500000  C352.232483,336.495575 356.935822,340.450714 362.017273,343.975067  C363.146301,344.758148 364.335236,345.332062 364.000000,347.000000  "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M473.500000,407.000000  C468.722595,406.786804 463.646210,406.847626 459.596222,404.344330  C455.315918,401.698730 450.733673,403.351654 446.500000,402.000000  "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M445.000000,255.000000  C447.191956,258.612305 447.272583,262.099091 444.509094,265.507385  C441.656342,269.025757 439.624695,272.946045 439.000000,277.500000  "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M502.500031,241.000031  C501.833374,241.833359 500.695007,242.603745 500.574066,243.509918  C499.537170,251.279572 494.228546,257.612915 493.383209,265.487457  C493.107056,268.059540 493.357574,271.243011 490.500000,273.000000  "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M385.500000,391.500000  C379.824860,392.094666 374.339661,394.303741 368.500000,393.500000  "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M511.500000,261.000000  C510.397766,266.471649 511.289185,272.003723 511.000000,277.500000  "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M394.500000,254.000000  C397.407776,255.462784 396.730103,258.738129 398.049133,260.970978  C400.257355,264.709076 401.827423,268.892365 405.020935,271.978333  C407.333405,274.212860 407.114441,277.609436 409.000000,280.000000  "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M525.500000,298.500000  C522.865173,304.555908 518.623657,309.419678 514.000000,314.000000  "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M427.000000,361.000000  C429.939880,363.769409 431.299683,367.512177 432.925812,371.034241  C433.788605,372.902985 434.622101,374.553192 436.500000,375.500000  "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M387.000000,647.000000  C392.058563,649.008728 397.340942,647.548523 402.500000,648.000000  "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M417.500000,260.500000  C416.821991,264.498108 417.020050,268.621552 415.563751,272.523804  C415.151398,273.628632 415.292114,275.083191 416.500000,276.000000  "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M544.500000,294.500000  C542.731506,299.958344 540.350159,305.022705 535.500000,308.500000  "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M348.000000,244.000000  C349.241272,242.581055 350.482574,241.162109 352.603394,238.737701  C351.551331,246.500000 354.578064,253.000000 352.000000,259.500000  "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M408.000000,361.500000  C404.838409,366.640198 400.895630,370.725769 394.500000,371.500000  "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M566.500000,675.500000  C566.044434,672.962952 568.066101,671.442566 569.038147,669.519287  C570.803101,666.026978 570.952026,662.231506 572.343506,658.558044  C567.715454,658.239868 565.566223,660.726013 564.073669,663.539062  C562.031494,667.387939 559.101379,668.361450 554.993591,668.101624  C552.026550,667.913940 549.000000,668.666687 546.000000,669.000000  "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M470.000000,249.000000  C467.336609,246.987732 466.823425,243.770065 465.485107,241.007217  C464.190674,238.334976 463.245056,235.158997 458.959167,236.899475  C458.073883,237.258987 456.673828,236.305267 455.498657,236.005295  C452.011078,235.115051 448.626556,234.767746 446.000000,238.000000  "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M451.000000,664.000000  C447.111023,668.289490 442.019226,670.087463 436.500000,671.000000  "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M420.000000,361.500000  C418.637817,360.072144 416.891357,359.134338 415.011017,359.549896  C403.909424,362.003326 393.745270,358.637390 383.452576,355.139587  C379.857605,353.917908 375.783630,352.451447 371.874939,355.856445  C370.300690,357.227814 367.326752,357.434814 365.001526,357.399597  C361.376221,357.344666 358.532623,359.075531 355.500000,360.500000  "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M450.500000,344.500000  C447.692657,349.618225 441.516388,350.725861 438.000000,355.000000  "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M477.500000,345.500000  C474.466736,350.703125 469.854248,354.039856 464.500000,356.500000  "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M498.500000,273.500000  C496.572083,277.619202 495.201813,281.867096 495.500000,286.500000  "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M379.500031,232.500000  C379.166687,236.833328 378.833344,241.166672 378.500031,245.500000  "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M389.500000,358.500000  C386.985779,362.908539 382.696259,365.147278 378.500000,367.500000  "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: " M444.500000,246.500000  C444.500000,247.500000 444.225220,248.600204 444.547058,249.482834  C446.018982,253.519501 443.817657,255.285706 440.502289,256.506256  C438.062988,257.404297 434.797455,257.564148 434.566071,261.004456  C434.268890,265.422028 434.740479,269.739166 439.500000,272.000000  "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M415.500000,660.500000  C410.574280,663.214905 409.739014,668.306824 408.703888,673.044556  C408.485474,674.044189 408.154907,676.769104 410.956268,677.640564  C412.998535,678.275940 414.772003,677.811279 415.916718,676.895874  C418.894684,674.514343 421.127075,671.358093 423.000000,668.000000  "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M499.500000,350.000000  C489.712982,350.333405 481.535065,355.779419 472.492554,358.475037  C470.881165,358.955414 469.541229,359.699280 468.500000,361.000000  "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M351.000000,341.000000  C355.856506,344.141022 361.206299,346.285492 366.534729,348.413025  C367.972229,348.986969 369.833344,348.500000 371.500000,348.500000  "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M205.500000,601.000000  C208.789154,604.465881 213.454071,603.804443 217.500000,605.000000  "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M602.500000,654.000000  C598.363708,655.609192 596.377991,658.640076 597.013672,662.497742  C597.263184,664.011597 597.629272,665.509460 598.006409,666.998352  C599.726990,673.790771 598.005859,677.000244 591.000000,680.000000  "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M514.500000,445.500000  C510.129333,445.626831 506.185577,446.844604 503.000000,450.000000  "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M445.500000,252.500000  C452.703369,249.893021 457.465851,251.396454 461.511749,257.492218  C462.431885,258.878510 463.500000,260.166656 464.500000,261.500000  "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M611.000000,664.000000  C607.886292,667.102417 604.891907,670.406860 600.000000,670.500000  "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M552.500000,601.000000  C555.435242,604.344849 559.703735,604.023132 563.500000,605.000000  "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M370.500000,244.000000  C371.459991,244.969528 372.270935,245.790451 372.066650,247.507935  C371.145111,255.255646 376.287415,259.677948 381.500000,264.000000  "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M267.500000,449.500000  C264.018036,447.658752 260.653809,445.493683 256.500000,445.500000  "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M332.500000,273.000000  C326.833344,272.329559 321.282135,271.431580 315.452911,272.799286  C312.386139,273.518860 308.833344,272.166656 305.500000,271.750000  "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M502.500000,510.500000  C499.018036,512.341248 495.653809,514.506348 491.500000,514.500000  "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M581.500000,660.500000  C579.827332,660.487976 578.575256,660.554871 577.339294,662.391846  C576.090149,664.248474 574.699463,666.965881 571.500000,666.500000  "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M456.500000,349.500000  C453.734528,352.442383 449.305237,353.204559 447.000000,356.750000  "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M532.000000,512.000000  C528.692200,513.640564 525.279175,514.839111 521.500000,514.500000  "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M404.000000,351.000000  C407.733643,351.954834 410.591217,354.953827 414.500000,355.500000  "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M502.500000,237.000000  C498.648987,236.359116 495.348602,238.030807 492.000000,239.500000  "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M457.500000,536.000000  C460.876190,536.857178 464.545929,536.735718 467.500000,539.000000  "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M495.500000,664.500000  C491.666809,663.333923 489.196594,667.619751 485.500000,667.000000  "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M411.500000,445.500000  C407.749847,445.475739 404.289185,446.278656 401.500000,449.000000  "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M423.500000,237.499985  C420.500000,240.666656 417.500000,243.833313 414.500000,246.999985  "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M561.500000,657.500000  C559.461487,660.551270 558.026794,663.844055 557.500000,667.500000  "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M399.500000,536.000000  C395.941010,536.769165 392.194061,537.068481 389.500000,540.000000  "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M247.500000,536.000000  C250.948715,537.044922 254.848770,536.961426 257.500000,540.000000  "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M505.500000,269.500000  C505.754547,272.662048 504.948334,275.879913 506.000000,279.000000  "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M589.500000,445.500000  C583.500000,448.300842 577.500000,446.642395 571.500000,445.500000  "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M405.500000,343.500000  C408.695587,348.961426 414.421783,351.048706 419.500000,354.000000  "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M444.500000,366.500000  C450.077759,366.128601 452.646271,370.915955 456.500000,373.500000  "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M383.000000,649.000000  C379.898743,647.590759 376.720306,647.647644 373.500000,648.500000  "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M269.500000,536.500000  C266.152832,536.773926 262.941223,537.396484 260.500000,540.000000  "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M257.500000,601.000000  C255.058777,603.603516 251.847168,604.226074 248.500000,604.500000  "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M417.500000,251.000000  C421.239105,248.218536 424.795166,245.320053 430.066071,247.863037  C431.554535,248.581146 434.133362,248.711273 435.500000,246.500000  "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M540.000000,662.000000  C541.527710,664.738159 541.921326,668.448425 546.000000,669.000000  "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M518.500000,662.000000  C521.506592,668.942810 523.062439,669.554016 532.500000,667.500000  "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M519.500000,561.500000  C517.502747,566.833313 517.328552,572.166687 519.500000,577.500000  "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M231.500000,562.500000  C231.483734,565.421997 230.470261,568.032349 229.000000,570.500000  "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M502.500000,355.500000  C499.861786,354.878326 497.073059,356.664337 494.500000,355.000000  "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M435.500000,364.500000  C439.365601,366.634399 441.328003,370.671997 444.500000,373.500000  "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M394.500000,350.500000  C397.166656,352.166656 399.833344,353.833344 402.500000,355.500000  "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M251.000000,649.000000  C248.406769,647.658325 245.731949,647.622253 243.000000,648.500000  "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M390.500000,237.000000  C393.000000,237.765717 395.484802,237.710861 398.003540,237.012817  C401.808411,235.958344 405.382019,236.327728 408.500000,239.000000  "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M255.000000,647.000000  C259.494843,649.103577 264.428040,647.116089 269.000000,648.500000  "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M433.500000,244.000000  C436.666656,246.000000 439.833344,248.000000 443.000000,250.000000  "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M484.500000,283.500000  C484.608307,285.338623 484.156647,287.228180 485.000000,289.000000  "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M528.500000,367.500031  C525.166687,368.333344 521.833313,369.166687 518.500000,370.000031  "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M385.500000,233.500000  C385.770111,235.156326 384.941315,236.922531 386.000000,238.500000  "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M369.000000,236.000000  C366.456268,236.549774 368.152222,239.454926 366.500000,240.500000  "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M402.500000,231.500000  C401.989563,233.069443 399.799713,233.892471 400.500000,236.000000  "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M400.000000,347.000000  C402.526520,348.899078 405.600525,350.680847 401.500000,354.000000  "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M481.500000,356.000000  C480.938385,357.871521 483.003510,360.698242 479.500000,361.500000  "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M503.500000,275.500000  C503.768219,276.820648 502.941986,278.278076 504.000000,279.500000  "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    d: " M511.500000,333.000000  C511.745056,333.986938 510.956207,335.146179 512.000000,336.000000  "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: " M459.000000,366.000000  C458.833344,367.166656 458.666687,368.333344 458.500000,369.500000  "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M334.500000,535.000000  C327.199188,536.235168 320.726837,539.121582 316.023438,545.018677  C306.165955,557.377869 305.230865,570.926880 310.433899,585.523560  C315.040314,598.446350 324.469513,605.138977 337.509888,605.806946  C351.549744,606.526184 360.898926,598.119263 365.766663,585.906982  C370.243378,574.675903 370.294525,562.604309 364.406891,551.549622  C358.252838,539.994629 348.243805,534.402466 335.000000,535.000000  "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M402.500000,46.500000  C393.228394,48.076145 383.812500,48.200008 374.480560,49.341011  C356.402161,51.551434 338.602600,54.859756 320.990234,59.462574  C282.981476,69.395782 247.217072,84.540627 214.027084,105.542801  C180.738297,126.607513 151.016983,151.789810 125.377502,181.895676  C109.320808,200.749435 94.925735,220.652023 82.534576,242.020050  C66.183311,270.217102 53.592499,299.962372 44.825294,331.451355  C39.361271,351.076385 35.148247,370.880157 32.653969,391.019073  C31.344467,401.592041 30.819019,412.298798 30.358391,422.993896  C29.486032,443.248718 30.409788,463.398468 32.568565,483.492645  C34.713818,503.460938 38.767738,523.094788 43.961971,542.510193  C50.933891,568.570435 60.700012,593.495972 72.956558,617.522156  C90.099518,651.127014 111.601402,681.552246 137.437759,709.058472  C160.017303,733.097290 185.273834,753.768311 213.009628,771.484924  C231.422241,783.246277 250.806686,793.178040 271.009399,801.477112  C288.104431,808.499573 305.597839,814.400757 323.508392,818.967041  C341.418945,823.533386 359.560974,826.688660 377.982788,828.660706  C394.312378,830.408691 410.639374,831.026306 426.999634,830.935303  C455.718292,830.775635 484.135376,827.371643 511.975555,820.402283  C552.508911,810.255432 590.371643,793.854004 625.558472,771.090332  C659.204285,749.323608 688.515442,722.833435 714.488708,692.490295  C728.766418,675.810486 741.404602,657.849731 752.325806,638.899597  C768.768250,610.369202 781.928345,580.284607 791.047485,548.513611  C796.567017,529.283752 800.847778,509.773010 803.347412,489.980743  C806.214050,467.283386 807.653137,444.376038 806.383118,421.506500  C804.266602,383.395508 797.993286,345.951752 785.471802,309.759766  C772.747742,272.981934 755.453491,238.538635 732.520386,206.985184  C708.540649,173.991714 680.197510,145.331039 647.482239,121.023918  C615.825378,97.503204 581.105957,79.541176 543.929688,66.703629  C523.537842,59.662010 502.478729,54.663383 481.019257,51.374329  C455.119568,47.404732 429.134216,46.073120 403.000000,46.500000  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dbc2751e32e8ab0e8821943cc71f45c4.svg";
export { ForwardRef as ReactComponent };